import { IApiError } from '@/models/apiError.model';
import { IPresignedFile } from '@/models/uploads.model';

export const UPLOADS_SLICE_NAME = 'uploads';

export interface UploadsState {
  file: IPresignedFile | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: UploadsState = {
  file: null,
  isLoading: false,
  error: null,
};
